export default [
  {
    path: '/prebecarios',
    name: 'prebecarios-list',
    component: () => import('@/views/prebecarios/PendientesPrebecarios.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Pre-Becarios',
      breadcrumb: [
        {
          text: 'Listado de prebecarios',
          active: true,
        },
      ],
    },
  },
  {
    path: '/prebecarios/observaciones',
    name: 'prebecarios-observaciones',
    component: () => import('@/views/prebecarios/ObservacionesPrebecarios.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Pre-Becarios',
      breadcrumb: [
        {
          text: 'Listado de prebecarios con observaciones',
          active: true,
        },
      ],
    },
  },
  {
    path: '/prebecarios/rechazados',
    name: 'prebecarios-rechazados',
    component: () => import('@/views/prebecarios/RechazadosPrebecarios.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Pre-Becarios',
      breadcrumb: [
        {
          text: 'Listado de prebecarios rechazados',
          active: true,
        },
      ],
    },
  },
  {
    path: '/prebecario/:id/detalles',
    name: 'prebecario-detalles',
    component: () => import('@/views/prebecarios/components/Detalles.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      pageTitle: 'Detalles prebecario',
      breadcrumb: [
        {
          text: 'Listado de prebecarios',
          to: '/prebecarios',
          active: false,
        },
        {
          text: 'Detalles prebecario',
          active: true,
        },
      ],
    },
  },
]
